export default __webpack_public_path__ + "static/glare-animation-daaa067539ceebef6973cd46f83458c6.gif";